import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import { createTheme, ThemeProvider } from "@mui/material/styles";

declare module "@mui/material/styles" {
  interface Palette {
    neutral: Palette["primary"];
  }
}

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

export default function BackdropLoadingScreen({
  openState,
  message,
  progressPercent,
  /** When true, stacks above MUI Modal/Dialog (default Backdrop sits below them). */
  stackAboveModal = false,
}: {
  openState: boolean;
  message?: string;
  progressPercent?: number;
  stackAboveModal?: boolean;
}) {
  const clampedProgress =
    typeof progressPercent === "number"
      ? Math.max(0, Math.min(100, progressPercent))
      : undefined;

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: (t) =>
              stackAboveModal ? t.zIndex.modal + 1 : t.zIndex.drawer + 1,
          }}
          open={openState}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 16,
            }}
          >
            {clampedProgress === undefined ? (
              <CircularProgress color="primary" />
            ) : (
              <div style={{ width: 280 }}>
                <LinearProgress
                  color="primary"
                  variant="determinate"
                  value={clampedProgress}
                />
                <span
                  style={{
                    fontFamily: "Mulish, sans-serif",
                    fontSize: 12,
                    display: "block",
                    marginTop: 6,
                    textAlign: "center",
                  }}
                >
                  {Math.round(clampedProgress)}%
                </span>
              </div>
            )}
            {message && (
              <span style={{ fontFamily: "Mulish, sans-serif" }}>
                {message}
              </span>
            )}
          </div>
        </Backdrop>
      </div>
    </ThemeProvider>
  );
}
